import React from "react";
import RelationsTotals from "@/components/RelationsTotals/RelationsTotals";
import { usePackagingProductRelations } from "@/pages/packaging/usePackagings";
import { useParams } from "react-router-dom";
import Table from "@/components/Table/Table";
import UnrelatedTag from "@/components/StatusTags/UnrelatedTag";
import useTableStateParams from "@/components/Table/hooks/useTableState";
import { productLabel } from "@/utilities/products";
import PrimarySourceTag from "@/components/StatusTags/PrimarySourceTag/PrimarySourceTag";
import ProxyTag from "@/components/StatusTags/ProxyTag/ProxyTag";

function PackagingProductRelations() {
  let { packagingId: id } = useParams();
  const packagingId = Number(id);

  const { pagination } = useTableStateParams({
    defaultPagination: { page: 1, pageSize: 10 },
  });

  const { data, isLoading } = usePackagingProductRelations({ packagingId, pagination });

  return (
    <>
      <RelationsTotals
        title={"Products"}
        isLoading={isLoading}
        count={data?.total_count || 0}
      />
      {data && data.relations.length > 0 && (
        <Table
          loading={isLoading}
          data={data?.relations}
          emptyState={{ hide: true }}
          hideRaster={true}
          totalRows={data?.total_count}
          pagination={pagination}
          rowLink={(record) => `/products/${record.id}`}
          columns={[
            {
              label: "Product",
              key: "id",
              renderer: (record) => productLabel(record.external_id, record.name),
            },
            {
              label: "Relation",
              key: "unrelated",
              renderer: (record) => (
                <>
                  {record.relation === "primary_source" ? <PrimarySourceTag /> : <ProxyTag />}
                  {record.unrelated && <UnrelatedTag />}
                </>
              ),
            },
          ]}
          rowKey={"id"}
        />
      )}
    </>
  );
}

export default PackagingProductRelations;
